import { Button } from "antd";
import { usePrintReport } from "./hooks/usePrintReport";
import { PrinterOutlined } from "@ant-design/icons";

type PrintCouponBtnProps = {
  accountNumber: number;
};

export const PrintCouponBtn = ({ accountNumber }: PrintCouponBtnProps) => {
  const { print, isLoading } = usePrintReport(
    {},
    accountNumber,
    "Coupons",
    "Coupon",
  );

  return (
    <Button
      type="link"
      className="pa-0"
      size="large"
      onClick={print}
      disabled={isLoading}
      icon={<PrinterOutlined />}
    >
      Coupon
    </Button>
  );
};
